<nav class="navbar">
    <app-logo class="white-link"></app-logo>
    <ul>
        <ng-container *ngFor="let link of config">
            <ng-container *appCheckPermissions="link.permission ? link.permission : permissions.open_access">
                <ng-container *ngIf="!link.disabled">
                    <li class="nav-item" [ngClass]="{ disabled: link.v2 }" *ngIf="!link.dropdownName">
                        <a [routerLink]="[link.link] | localize" class="icon icon__menu {{ link.icon }}" href="#" routerLinkActive="-active">
                            <b></b>
                            <b></b>
                            <span>{{ link.title | translate }}</span>
                            <span *ngIf="link.v2" class="badge">{{ 'NAV.SIDE-NAV.V2' | translate }}</span>
                        </a>
                    </li>

                    <ng-container *ngIf="link.dropdownName">
                        <li
                            [routerLinkActiveOptions]="{ exact: true }"
                            [ngClass]="{ disabled: link.v2 }"
                            class="nav-item"
                            routerLinkActive="active"
                        >
                            <a
                                (click)="openMenuDropdown()"
                                #dropdownLink
                                aria-controls="navbarDropdown"
                                aria-expanded="false"
                                class="nav-link icon icon__menu {{ link.icon }}"
                                data-bs-toggle="collapse"
                                href="#{{ link.dropdownName }}"
                                role="button"
                            >
                                <span>{{ link.title | translate }}</span>
                                <span *ngIf="link.v2" class="badge">{{ 'NAV.SIDE-NAV.V2' | translate }}</span>
                            </a>
                            <span
                                *ngIf="link.link.includes('messaging') && (unreadMessagesCount$ | async) > 0"
                                class="unread-count"
                                [ngClass]="{ wide: (unreadMessagesCount$ | async) > 9, wider: (unreadMessagesCount$ | async) > 99 }"
                            >
                            {{ unreadMessagesCount$ | async }}
                        </span>
                            <ul *ngIf="isMenuOpen$ | async" class="collapse sub-list" [id]="link.dropdownName">
                                <ng-container *ngFor="let child of link.childrens">
                                    <li
                                        [ngClass]="{ disabled: child.v2 }"
                                        *appCheckPermissions="child.permission ? child.permission : permissions.open_access"
                                    >
                                        <a [routerLink]="[child.link] | localize" class="icon {{ child.icon }}" routerLinkActive="-active">
                                            <b></b>
                                            <b></b>
                                            {{ child.title | translate }}
                                            <span *ngIf="child.v2" class="badge">{{ 'NAV.SIDE-NAV.V2' | translate }}</span>
                                        </a>
                                        <span
                                            *ngIf="child.link.includes('received-messages') && (unreadMessagesCount$ | async) > 0"
                                            class="unread-count"
                                            [ngClass]="{ wide: (unreadMessagesCount$ | async) > 9, wider: (unreadMessagesCount$ | async) > 99 }"
                                        >
                                        {{ unreadMessagesCount$ | async }}
                                    </span>
                                        <span *ngIf="child.unread" class="unread-count new">{{ unreadNotif }}</span>
                                    </li>
                                </ng-container>
                            </ul>
                        </li>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </ul>
</nav>
<nav class="subnav-top" *ngIf="isShopping || isMessaging">
    <ng-container *ngFor="let link of config">
        <ul *ngIf="url.includes(link.link)">
            <ng-container *ngFor="let child of link.childrens">
                <li
                    class="nav-item"
                    [ngClass]="{ disabled: child.v2 }"
                    *appCheckPermissions="child.permission ? child.permission : permissions.open_access"
                >
                    <a [routerLink]="[child.link] | localize" routerLinkActive="-active" class="icon {{ child.icon }}">
                        <span>{{ child.title | translate }}</span>
                        <span *ngIf="child.v2" class="badge">{{ 'NAV.SIDE-NAV.V2' | translate }}</span>
                        <span class="highlight"></span>
                    </a>
                    <span
                        *ngIf="child.link.includes('received-messages') && (unreadMessagesCount$ | async) > 0"
                        class="unread-count top"
                        [ngClass]="{
                            '-active': isReceivedMessages,
                            wide: (unreadMessagesCount$ | async) > 9,
                            wider: (unreadMessagesCount$ | async) > 99
                        }"
                    >
                        {{ unreadMessagesCount$ | async }}
                    </span>
                </li>
            </ng-container>
        </ul>
    </ng-container>
</nav>
<nav class="navbar-mobile">
    <ul>
        <ng-container *ngFor="let link of config">
            <li
                class="nav-item"
                [ngClass]="{ disabled: link.v2 }"
                *appCheckPermissions="link.permission ? link.permission : permissions.open_access"
            >
                <a
                    [routerLink]="(link.hasSecondaryLink && link.secondaryLink !== '' ? [link.secondaryLink] : [link.link]) | localize"
                    class="icon icon__menu {{ link.icon }}"
                    href="#"
                    routerLinkActive="-active"
                >
                    <span>{{ link.title | translate }}</span>
                    <span *ngIf="link.v2" class="badge">{{ 'NAV.SIDE-NAV.V2' | translate }}</span>
                </a>
                <span
                    *ngIf="link.link.includes('messaging') && (unreadMessagesCount$ | async) > 0"
                    class="unread-count"
                    [ngClass]="{
                        '-active': isMessaging,
                        wide: (unreadMessagesCount$ | async) > 9,
                        wider: (unreadMessagesCount$ | async) > 99
                    }"
                >
                    {{ unreadMessagesCount$ | async }}
                </span>
            </li>
        </ng-container>
    </ul>
</nav>
